import { render, staticRenderFns } from "./infodevice.vue?vue&type=template&id=2d5224c2"
import script from "./infodevice.vue?vue&type=script&lang=js"
export * from "./infodevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Repos\\StopRiparo_Piattaforma\\Piattaforma.Client\\wwwroot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d5224c2')) {
      api.createRecord('2d5224c2', component.options)
    } else {
      api.reload('2d5224c2', component.options)
    }
    module.hot.accept("./infodevice.vue?vue&type=template&id=2d5224c2", function () {
      api.rerender('2d5224c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/ticket/views/infodevice.vue"
export default component.exports